import { render } from "./protocol_positions2.vue?vue&type=template&id=959294b0"
import script from "./protocol_positions2.vue?vue&type=script&lang=js"
export * from "./protocol_positions2.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_positions2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "959294b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('959294b0', __exports__)) {
    console.log('reload')
    api.reload('959294b0', __exports__)
  }
  
  module.hot.accept("./protocol_positions2.vue?vue&type=template&id=959294b0", () => {
    console.log('re-render')
    api.rerender('959294b0', render)
  })

}


export default __exports__